<template>
    <div>
        <ValidationObserver ref="storeModalValidate">
                <b-col cols="12">
                    <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('concentration')">
                            <ConcentrationSelectbox v-model="formData.program_expertise_id" :program_code="program_code"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider
                        name="slot_type"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('slot_type')">
                            <slot-type-selectbox
                                ref="slotType"
                                v-model="formData.slot_type"
                                :state="errors[0] ? false : null"
                                :validate-error="errors[0]"
                            ></slot-type-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" v-if="slotType">
                    <b-row>
                    <div v-if="slotType.filter=='course'" class="col-12 col-sm-12 col-md-12">
                        <ValidationProvider name="course_id" rules="required"
                                            v-slot="{ valid, errors }">
                            <b-form-group :label="$t('course')">
                                <course-auto-complete
                                    v-model="formData.course_id"
                                    :valueObject="{value: formData.course_id, text: formData.course_code}"
                                    :validate-error="errors[0]"
                                ></course-auto-complete>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div v-else class="col-12 col-sm-12 col-md-12">
                        <ValidationProvider
                            name="pool_id"
                            rules="required"
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('pool')">
                                <elective-pool-selectbox
                                    :type="formData.slot_type"
                                    :programCode="program_code"
                                    v-model="formData.pool_id"
                                    :state="errors[0] ? false : null"
                                    :validate-error="errors[0]"
                                ></elective-pool-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    </b-row>
                </b-col>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="createForm" :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
    // Other
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import ConcentrationSelectbox from '@/components/interactive-fields/ProgramConcentrationsSelectbox.vue'
    import ElectivePoolSelectbox from "@/components/interactive-fields/ElectivePoolSelectbox.vue";
    import SlotExpertiesServices from "@/services/SlotExpertiesServices";
    import {mapGetters} from "vuex";
    import SlotTypeSelectbox from "@/components/interactive-fields/SlotTypeSelectbox.vue";

    export default {
        props:{
            selectedSlotId: {
                type: Number,
            },
        },
        components: {
            SlotTypeSelectbox,
            ElectivePoolSelectbox,
            ValidationObserver,
            ValidationProvider,
            ConcentrationSelectbox
        },
        data() {
            return {
                formData: {
                    program_expertise_id:null,
                    pool_id: null,
                    course_id: null,
                    slot_type: null,
                },
                slotType: null,
                formLoading: false
            }
        },
        computed:{
          ...mapGetters({
              slot_type:"slots/getSlotType",
              program_code:"slots/getProgramCode"
          })
        },
        watch:{
            'formData.slot_type': function (selected) {
                this.slotType = this.$refs.slotType.getItem(selected);
            },
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.storeModalValidate.validate();
                if(this.slotType.filter=='course'){
                    this.formData.pool_id=null;
                }
                else {
                    this.formData.course_id=null;
                }
                if (this.formData.pool_id != null && this.formData.course_id != null) {
                    this.$toast.error(this.$t('Course and Elective pool cannot be used together. Please select only one.'));
                    return
                }
                if (isValid) {
                    this.formData.slot_id=this.selectedSlotId;
                    if (this.formData.pool_id != null) delete this.formData.course_id;
                    if (this.formData.course_id != null) delete this.formData.pool_id;
                    SlotExpertiesServices.store(this.formData)
                                                    .then(response => {
                                                        this.$toast.success(this.$t('api.' + response.data.message));
                                                        this.$emit('createFormSuccess', true);
                                                    })
                                                    .catch(e => {
                                                        this.showErrors(e,this.$refs.storeModalValidate);
                                                    })
                                                    .finally(() => {
                                                        this.formLoading = false
                                                    })


                }
            }
        }
    }
</script>

